import React, { Fragment } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import {
  Container, Icon, Image, Menu, Dropdown,
} from 'semantic-ui-react';
import ButtonLinkRoomConference from '../../../components/forms/ButtonLinkRoomConference';
import FooterLayout from './FooterLayout';

const DesktopPageLayout = ({
  children, auth, authenticationLogout, Media,
}) => (
  <Fragment>
    <Media className="fresnel-container-sidebar" greaterThan="mobile">
      <Menu size="large" pointing color="teal" fixed="top" borderless inverted>
        <Container>
          { auth.isAuthorized && (
            <Fragment>
              <Menu.Item style={{ paddingRight: '25px' }} fitted="horizontally" header>
                Doug Vet
              </Menu.Item>
              <Menu.Item as={Link} to="/">
                <Icon name="heartbeat" />
                Dashboard
              </Menu.Item>
              <Menu.Item as={Link} to="/pacientes">
                <Icon name="address book outline" />
                Mis Pacientes
              </Menu.Item>
              <Menu.Item as={Link} to="/perfil">
                <Icon name="doctor" />
                Mi Perfil
              </Menu.Item>
              <Menu.Item>
                <ButtonLinkRoomConference />
              </Menu.Item>
              <Menu.Menu position="right">
                <Menu.Item>
                  <div>
                    <Image size="mini" src={auth.data && auth.data.avatar} avatar />
                    <span
                      style={{ marginLeft: '5px' }}
                    >
                      {auth.data && auth.data.prefijo}
                      {' '}
                      {auth.data && auth.data.nombre}
                      {' '}
                      {auth.data && auth.data.apellido}
                    </span>
                  </div>
                </Menu.Item>
                <Dropdown item style={{ paddingLeft: 0, paddingRight: '1em' }}>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => authenticationLogout()}>
                      Salir
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Menu>
            </Fragment>
          )}
          { auth.isAuthenticated && !auth.isAuthorized && (
            <Menu.Menu position="right" borderless>
              <Menu.Item>
                <div>
                  <span style={{ marginLeft: '5px' }}>
                    Usuario no registrado
                  </span>
                </div>
              </Menu.Item>
            </Menu.Menu>
          )}
        </Container>
      </Menu>
      { auth.isAuthorized && children }
      <FooterLayout />
    </Media>
  </Fragment>
);

DesktopPageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  auth: PropTypes.any.isRequired.isRequired,
  authenticationLogout: PropTypes.func.isRequired,
  Media: PropTypes.node.isRequired,
};

export default DesktopPageLayout;



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/components/DesktopPageLayout.js